module.exports = __webpack_public_path__ + "img/got_questions_img_min.42250a13.png";